import React from 'react';

export default function ComingSoon({ label = 'This module' }) {
    return (
        <div className="container" style={{ opacity: 0.75 }}>
            <h3>{label}</h3>
            <p>{label} is coming soon.</p>
        </div>
    );
}
